<script>
export default {
    name: 'IlluCalendrier',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-calendrier"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M50 14H14a4 4 0 00-4 4v28a4 4 0 004 4h32a8 8 0 008-8V18a4 4 0 00-4-4zM10 24h44m-34.5-5V9m25 10V9M32 19V9"
                :stroke="secondaryColor" class="secondary-color"
                stroke-linecap="round"
            />
            <path d="M53.5 43H51a4 4 0 00-4 4v.364h0V49.5" :stroke="secondaryColor" class="secondary-color" />
            <path
                d="M25 38v6h-6v-6h6zm10 0v6h-6v-6h6zm-10-9v6h-6v-6h6zm10 0v6h-6v-6h6zm10 0v6h-6v-6h6z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
